export default __webpack_public_path__ + "static/media/ip_blacklist.d01aa312.svg";